import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;

    > section {
      display: flex;
      align-items: center;
      column-gap: ${theme.layout.spacing(3)};

      .info {
        display: flex;
        flex-direction: column;
        gap: ${theme.layout.spacing(0.5)};

        span {
          color: ${theme.palette.text.light};
          font-size: ${theme.typography.sizes.body2};

          strong {
            color: inherit;
            font-size: inherit;
            font-weight: ${theme.typography.weight.bold};
          }
        }

        strong {
          color: ${theme.palette.text.main};
          font-size: ${theme.typography.sizes.title3};
          font-weight: ${theme.typography.weight.bold};
        }
      }
    }
  `}
`;

export const Tooltip = styled.div`
  ${({ theme }) => css`
    padding: ${theme.layout.spacing(1, 2)};

    > span {
      color: ${theme.palette.text.light};
      font-size: ${theme.typography.sizes.body2};
      font-weight: ${theme.typography.weight.regular};
    }
  `}
`;

export const Warning = styled.div`
  ${({ theme }) => css`
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 12px;
    background-color: ${transparentize(0.7, theme.palette.warning.light)};

    > svg {
      font-size: 1rem;
      color: ${theme.palette.warning.dark};
    }
  `}
`;
